import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, memo, useState, useMemo } from 'react';

const VideosUploaderContext = /*#__PURE__*/createContext({
  videos: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  add: () => {}
});
const VideosUploaderProvider = /*#__PURE__*/memo(props => {
  const [videos, setVideos] = useState([]);
  const add = v => __awaiter(void 0, void 0, void 0, function* () {
    return setVideos([...v]);
  });
  const value = useMemo(() => ({
    videos,
    add
  }), [videos]);
  return jsx(VideosUploaderContext.Provider, Object.assign({
    value: value
  }, {
    children: props.children
  }));
});

export { VideosUploaderContext, VideosUploaderProvider };
